export const getList = state => state.list;

export const resources = state => state.resources;
export const resourcesCount = state => state.resourcesCount;
export const currentPage = state => state.currentPage;

export const list = state => state.list;
export const invoice = state => state.invoice || {};
export const newLinkStatus = state => state.newLinkStatus;
export const newLinkError = state => state.newLinkError;

export const loadingData = state => state.loadingData;
export const invoiceErrorStatus = state => state.invoiceErrorStatus;
export const invoiceErrorMessage = state => state.invoiceErrorMessage;
export const newInvoiceStatus = state => state.newInvoiceStatus;
export const link = state => state.link;

export const initialDate = state => state.initialDate;
export const finalDate = state => state.finalDate;
export const status = state => state.status;
export const limitOptions = state => state.limitOptions;
export const limit = state => state.limit;
export const ordination = state => state.ordination;
export const subtotal = state => state.subtotal;

export const filterVisible = state => state.filterVisible;

// Subscriptions
export const subscriptionSet = state => state.subscriptionSet;
export const subscription = state => state.subscription;
export const subscriptionsList = state => state.subscriptions.resources;
export const subscriptionsResourcesCount = state => state.subscriptions.resourcesCount;
export const subscriptionsCurrentPage = state => state.subscriptions.currentPage;
export const subscriptionsLoadingData = state => state.subscriptions.loadingData;
export const subscriptionsStatus = state => state.subscriptions.status;
export const subscriptionsLimitOptions = state => state.subscriptions.limitOptions;
export const subscriptionsLimit = state => state.subscriptions.limit;
export const subscriptionsFilter = (state) => {
  const subscriptionsFilters = {
    page: state.subscriptions.currentPage || 1,
    limit: state.subscriptions.limit,
  };
  return subscriptionsFilters;
};

// Eletronic Payments
export const newEletronicPayment = state => state.newEletronicPayment;
export const location = state => state.location;
export const eletronicPayment = state => state.eletronicPayment;
export const eletronicPaymentsList = state => state.eletronicPayments.resources;
export const eletronicPaymentsResourcesCount = state => state.eletronicPayments.resourcesCount;
export const eletronicPaymentsCurrentPage = state => state.eletronicPayments.currentPage;
export const eletronicPaymentsLoadingData = state => state.eletronicPayments.loadingData;
export const eletronicPaymentsStatus = state => state.eletronicPayments.status;
export const eletronicPaymentsLimitOptions = state => state.eletronicPayments.limitOptions;
export const eletronicPaymentsLimit = state => state.eletronicPayments.limit;
export const eletronicPaymentsFilter = (state) => {
  const eletronicPaymentsFilters = {
    page: state.eletronicPayments.currentPage || 1,
    limit: state.eletronicPayments.limit,
  };
  return eletronicPaymentsFilters;
};

// Eletronic Receipts
export const newEletronicReceipt = state => state.newEletronicReceipt;
export const eletronicReceipt = state => state.eletronicReceipt;
export const eletronicReceiptsList = state => state.eletronicReceipts.resources;
export const eletronicReceiptsResourcesCount = state => state.eletronicReceipts.resourcesCount;
export const eletronicReceiptsCurrentPage = state => state.eletronicReceipts.currentPage;
export const eletronicReceiptsLoadingData = state => state.eletronicReceipts.loadingData;
export const eletronicReceiptsStatus = state => state.eletronicReceipts.status;
export const eletronicReceiptsLimitOptions = state => state.eletronicReceipts.limitOptions;
export const eletronicReceiptsLimit = state => state.eletronicReceipts.limit;
export const eletronicReceiptsFilter = (state) => {
  const eletronicReceiptsFilters = {
    page: state.eletronicReceipts.currentPage || 1,
    limit: state.eletronicReceipts.limit,
  };
  return eletronicReceiptsFilters;
};

export const filter = (state) => {
  const filters = {
    page: (state.currentPage || 1),
    limit: state.limit,
    'filterrific[with_duedate_between][start_at]': state.initialDate,
    'filterrific[with_duedate_between][end_at]': state.finalDate,
    'filterrific[status]': state.status,
    'filterrific[sorted_by]': state.ordination,
  };
  return filters;
};
